import { Menu } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

interface MobileMenuProps {
  anchorEl: HTMLElement | null
  open: boolean
  onClose: () => void
}

export const MobileMenu: FC<MobileMenuProps & PropsWithChildren> = ({
  open,
  anchorEl,
  children,
  onClose
}) => {
  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      anchorReference="anchorEl"
      slotProps={{
        paper: {
          sx: {
            width: anchorEl ? (anchorEl as HTMLElement).offsetWidth : 'auto',
            maxWidth: '100%',
          },
        },
        list: {
          role: 'listbox',
        },
      }}
    >
      {children}
    </Menu>
  )
}
